import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { View, Text } from "react-native";

import InputChoose from "@/components/input/InputChoose";
import {
  WalletWidget,
  WidgetInformation,
} from "@/components/web3/WalletWidget";
import {
  BridgeLiquidationAddressChain,
  BridgeVirtualAccountPaymentCurrency,
} from "@/utils/dto/extracted_enums";

interface WalletInformation extends WidgetInformation {
  rail: string;
  currency: string;
}

interface Props {
  setWalletInformation: (walletInformation: WalletInformation) => void;
  reset?: boolean;
}

export default function CreateWalletAddress(props: Props) {
  const [walletAddress, setWalletAddress] = useState<string>("");
  const [isTronWallet, setIsTronWallet] = useState<boolean>(false);
  const [rail, setRail] = useState<string>("");
  const [currency, setCurrency] = useState<string>("");
  const { t } = useTranslation();

  const { control, reset } = useForm<any>({
    mode: "onSubmit",
  });

  useEffect(() => {
    if (props.reset) {
      reset();
    }
    props.setWalletInformation({
      walletAddress,
      isTronWallet,
      rail,
      currency,
    });
  }, [props.reset, rail, currency, walletAddress, isTronWallet]);

  return (
    <View className="w-full items-center gap-3">
      <WalletWidget
        setWalletAddress={(address) => console.log("Connected wallet", address)}
        setWidgetInformation={(widgetInformation) => {
          setWalletAddress(widgetInformation.walletAddress);
          setIsTronWallet(widgetInformation.isTronWallet);
        }}
        smallVersion
      />
      <Text className="text-lg font-bold">
        {t("home/amount:sendwithwallet.title")}
      </Text>
      <View className="z-50">
        <InputChoose
          label={t("home/amount:sendwithwallet.input.paymentrail")}
          name="paymentRail"
          data={{ BridgeLiquidationAddressChain }}
          handleChange={(text: string) => setRail(text)}
          control={control}
          optional={false}
          blocked={false}
        />
      </View>
      <View className="z-40">
        <InputChoose
          label={t("home/amount:sendwithwallet.input.currency")}
          name="currency"
          data={{ BridgeVirtualAccountPaymentCurrency }}
          handleChange={(text: string) => setCurrency(text)}
          control={control}
          optional={false}
          blocked={false}
        />
      </View>
    </View>
  );
}
